import { createAction } from '@reduxjs/toolkit';
import { saveToLocalStorage } from '@/lib/helpers';

export const setSalesOrdersSearchActiveFilters = createAction(
  'sales-orders-search/active-filters/save'
);
export const _setSalesOrdersSearchActiveFilters = (activeFilters) => (dispatch) => {
  if (activeFilters === null) {
    activeFilters = {
      season: '',
      brand: '',
      type: '',
      status: '',
    };
  }
  saveToLocalStorage('salesOrderListActiveFilters', activeFilters);
  dispatch(setSalesOrdersSearchActiveFilters(activeFilters));
};

export const setSalesOrdersActiveTab = createAction('sales-orders-search/active-tab/save');

export const setSalesOrdersActiveShopId = createAction('sales-orders-search/active-shop-uuid/save');
